import React, { Component } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

const badges={

 
  coinSystem: require( "../imgs/badges/brs/BR - System Integrator.png"),
coinScripting: require ("../imgs/badges/brs/BR - Scripting.png"),
coinHost: require ("../imgs/badges/brs/BR - Host Analyst.png"),
 coinNetwork:  require ("../imgs/badges/brs/BR - Network Analyst.png"),
 coinPowerShell:  require ( "../imgs/badges/brs/BR - PowerShell Fundamentals.png"),
 coinIntel:  require ( "../imgs/badges/brs/BR - Intel Analyst.png"),
 coinLinux:  require ( "../imgs/badges/brs/BR - Linux Basics.png"),
coinTraffic:  require ( "../imgs/badges/brs/BR - Network Packet Analysis.png"),
 coinForensics: require ("../imgs/badges/brs/BR - Forensics One.png"),

 coinHerd: require ("../imgs/badges/missions/M1 - Goat Herd.png"),
 coinWolf: require ("../imgs/badges/missions/M10 - Crimson Wolf.png"),
 coinHermit: require ("../imgs/badges/missions/M12 - Bold Hermit.png"),
 coinDragon: require ("../imgs/badges/missions/M13 - Black Dragon.png"),
 coinBear: require ("../imgs/badges/missions/M2 - Bear Treat.png"),
 coinWhale: require ("../imgs/badges/missions/M3 - Desert Whale.png"),
 coinCobra: require ("../imgs/badges/missions/M4 - Arctic Cobra.png"),
 coinWBear: require ("../imgs/badges/missions/M5 - Wounded Bear.png"),
 coinTiger: require ("../imgs/badges/missions/M6 - Angry Tiger.png"),
 coinOcean: require ("../imgs/badges/missions/M8 - Ocean View.png"),
 coinWFlash: require ("../imgs/badges/missions/M9 - Waterfall Flash.png"),
 coinWBear: require ("../imgs/badges/missions/M5 - Wounded Bear.png"), 
 coinBR22: require ("../imgs/badges/brs/BR - MS Cloud App Security.png"), 
 coinBR29: require ("../imgs/badges/brs/br29.png"), 

 coinCTF1: require ("../imgs/badges/brs/BR - CTF1.png"),
 coinCTF2: require ("../imgs/badges/brs/BR - CTF2.png"),
 coinCTF3:require ("../imgs/badges/brs/BR - CTF3.png"),
 coinCTF4: require ("../imgs/badges/brs/BR - CTF4.png"),
 coinCTF5: require ("../imgs/badges/brs/BR - CTF5.png"),



};


function isNumber(n) {
  return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
}



function Grid(props, e) {
 

 
  return (
    <>
   <div className="scenarios-grid">
          { props.access.map((key, index) => {
                return (
                  <Link key={index} to={"/cyber-curriculum-guide/" + key}>
                  
                    <img
                      alt="badge"
                      src={
                        badges[
                          props.props.scenarios[
                            isNumber(key[key.length - 1])
                              ? key.toLowerCase()
                              : key.substring(0, key.length - 1).toLowerCase()
                          ]
                            ? props.props.scenarios[
                                isNumber(key[key.length - 1])
                                  ? key.toLowerCase()
                                  : key
                                      .substring(0, key.length - 1)
                                      .toLowerCase()
                              ].coin
                            : " "
                        ]
                          ? badges[
                              props.props.scenarios[
                                isNumber(key[key.length - 1])
                                  ? key.toLowerCase()
                                  : key
                                      .substring(0, key.length - 1)
                                      .toLowerCase()
                              ]
                                ? props.props.scenarios[
                                    isNumber(key[key.length - 1])
                                      ? key.toLowerCase()
                                      : key
                                          .substring(0, key.length - 1)
                                          .toLowerCase()
                                  ].coin
                                : " "
                            ].default
                          : badges["coinFallback"].default
                      }
                    />

                    {key}-
                  { 
                      props.props.scenarios[
                          isNumber(key[key.length - 1])
                            ? key.toLowerCase()
                            : key.substring(0, key.length - 1).toLowerCase()
                        ]
                        ? props.props.scenarios[
                            isNumber(key[key.length - 1])
                              ? key.toLowerCase()
                              : key.substring(0, key.length - 1).toLowerCase()
                          ].title
                        : "no title"
                      }
                  </Link>
                );
              })
            }
        </div>
    </>
  );
}




function ScenarioSelect(props, e) {
 

  return (
    <>
      <div className="dropdown">
        <button className="dropbtn">
          <h1 style={{ fontSize: "1em" }}>
            {" "}
            {props.props.location}-
            {props.props.scenarios[
              isNumber(props.props.location[props.props.location.length - 1])
                ? props.props.location.toLowerCase()
                : props.props.location
                    .substring(0, props.props.location.length - 1)
                    .toLowerCase()
            ]
              ? props.props.scenarios[
                  isNumber(
                    props.props.location[props.props.location.length - 1]
                  )
                    ? props.props.location.toLowerCase()
                    : props.props.location
                        .substring(0, props.props.location.length - 1)
                        .toLowerCase()
                ].title
              : "no title"}
            <i className="fa fa-caret-down"></i>
          </h1>
        </button>
        <div className="dropdown-content">
          {props.access.map((key, index) => {
            return (
              <Link
                key={key}
                to={"/cyber-curriculum-guide/" + key}
                onClick={(event) => {
                  // props.props.clearData();
                  //handleClick(key);
                  props.props.handleLocationChange(key);
                  // window.location.href =            "/cyber-curriculum-guide/" + event.target.value;
                  //history.push(  "/cyber-curriculum-guide/" + event.target.value);
                }}
              >
                {key}-
                {props.props.scenarios[
                  isNumber(key[key.length - 1])
                    ? key.toLowerCase()
                    : key.substring(0, key.length - 1).toLowerCase()
                ]
                  ? props.props.scenarios[
                      isNumber(key[key.length - 1])
                        ? key.toLowerCase()
                        : key.substring(0, key.length - 1).toLowerCase()
                    ].title
                  : "no title"}
              </Link>
            );
          })}
        </div>
      </div>
    </>
  );
}

class Links extends Component {
  constructor(props) {
    super(props);
    this.state = {
      access: this.props.master.access
        .filter(this.checkBR)
        .sort((a, b) => a.replace(/\D/g, "") - b.replace(/\D/g, ""))
        .concat(
          this.props.master.access
            .filter(this.checkM)
            .sort((a, b) => a.replace(/\D/g, "") - b.replace(/\D/g, ""))
        ),
    };
  }

  checkBR(scenario) {
    return scenario.includes("BR");
  }

  checkM(scenario) {
    return scenario.includes("M");
  }

  componentDidMount(){
   
  }


  render() {
    return this.props.grid ? (
      <>
    
      <Grid props={this.props} access={this.state.access}/>
        {/*this.props.email.split("@")[1] == "circadence.com" ? (
          <div className="circ-only">
            <h5> Hello {this.props.email} YAMLS:</h5>
            <br />
            <h5>Masterlist:</h5>
            {this.state.access
              ? this.state.access.map((key, index) => {
                  return (
                    <a key={index} href={"/cyber-curriculum-guide/" + key}>
                      {" "}
                      {key}
                    </a>
                  );
                })
              : ""}
            <br />
            <br />
            <h5> YAMLS:</h5>
            {this.props.links
              ? this.props.links.map((key, index) => {
                  return (
                    <a key={index} href={"/cyber-curriculum-guide/" + key}>
                      {" "}
                      {key}
                    </a>
                  );
                })
              : ""}
          </div>
        ) : (
          " "
        )*/}
      </>
    ) : this.props.master.access && this.props.scenarios ? (
      <ScenarioSelect props={this.props} access={this.state.access} />
    ) : (
      "select"
    );
  }
}
export default Links;